import React, { useCallback } from 'react';
import { Box, RawButton, ShimmerBox, Text, useWatch } from '@common-fe/common-fe';
import styled from 'styled-components';

import { ROUTES } from '@/common';
import { useBreadcrumbs } from '@/modules/core/hooks';
import { useScrollToModule } from '@/utils';

const StyledText = styled(Text)``;
const StyledButton = styled(RawButton)`
  &:hover {
    ${StyledText} {
      color: ${({ theme}) => theme.colors.textAccent}
    }
  }
`;

interface Props {
  isLoading?: boolean;
}
const FieldLevelAccessSetupSidebar: React.FC<Props> = ({ isLoading }) => {
  const name = useWatch({
    name: 'name'
  });
  useBreadcrumbs([{
    route: ROUTES.ROLES_AND_SECURITY,
    title: 'Roles and Security',
  },
  {
    route: ROUTES.FIELD_LEVEL_ACCESS_SETUP,
    title: name,
  }], [name], {
    backBtn: true,
  });
  const handleScroll = useScrollToModule('role_setup', 100);
  const handleClick = useCallback((key: string) => () => {
    handleScroll(key);
 
  }, [handleScroll]);
  return (
    <Box direction='column' width={{min: '280px'}} pad={{horizontal: 'l', top: 'spacing20'}} background="module">
      {isLoading ? (
        <ShimmerBox height="40px" />
      ) : (
        <Text size="2xl" color="textTitle" weight={700} data-testid="FieldLevelAccessSetupSidebarTitle">
          {name}
        </Text>
      )}
      
      <StyledButton margin={{bottom: 'xxs'}}onClick={handleClick('basic_properties')}>
        <StyledText weight={400} data-testid="FieldLevelAccessSetupSidebarBasicProperties">
          Basic Properties
        </StyledText>
      </StyledButton>
      <StyledButton margin={{bottom: 'xxs'}}onClick={handleClick('normal_organization_properties')}>
        <StyledText weight={400} data-testid="FieldLevelAccessSetupSidebarNormalOrganizationProperties">
          Normal Organization Properties
        </StyledText>
      </StyledButton>
      <StyledButton margin={{bottom: 'xxs'}}onClick={handleClick('overridable_organization_properties')}>
        <StyledText weight={400} data-testid="FieldLevelAccessSetupSidebarOverridableOrganizationProperties">
          Overridable Organization Properties
        </StyledText>
      </StyledButton>
      <StyledButton margin={{bottom: 'xxs'}}onClick={handleClick('final_setup')}>
        <StyledText weight={400} data-testid="FieldLevelAccessSetupSidebarFinalSetup">
          Final Setup
        </StyledText>
      </StyledButton>
    </Box>
  );
};

export default FieldLevelAccessSetupSidebar;